import sortBy from "./sortBy.js";

export default function sort(arr) {
  return sortBy(a => a, arr);
}